import React, { Dispatch, SetStateAction, useEffect } from 'react';
import GridIntegrationsMenu, {
    IntegrationsConfig,
} from '@components-clean/core/grid/grid-menu/grid-settings-menu/grid-integrations-menu';
import GridLockMenu from '@components-clean/core/grid/grid-menu/grid-settings-menu/grid-lock-menu';
import GridVisibilityMenu from '@components-clean/core/grid/grid-menu/grid-settings-menu/grid-visibility-menu';
import { GridColumnProps } from '@components-clean/core/grid/grid.interface';
import { useBoolean } from '@hooks/index';

interface GridSettingsMenuProps {
    columns: GridColumnProps[];
    closeMenu?: () => void; // NOTE: This property passed from the GridMenuItem component
    updateColumns: Dispatch<SetStateAction<GridColumnProps[]>>;
    lockedColumnsUpdated: ReturnType<typeof useBoolean>;
    hiddenColumnsUpdated: ReturnType<typeof useBoolean>;
    integrationsOptions?: IntegrationsConfig;
}

const GridSettingsMenu = ({
    columns,
    updateColumns,
    closeMenu,
    lockedColumnsUpdated,
    hiddenColumnsUpdated,
    integrationsOptions,
}: GridSettingsMenuProps) => {
    const lockExpanded = useBoolean(false);
    const visibilityExpanded = useBoolean(false);
    const integrationsExpanded = useBoolean(false);

    useEffect(() => {
        if (lockExpanded.value) {
            visibilityExpanded.setFalse();
            integrationsExpanded.setFalse();
        }
    }, [lockExpanded.value]);

    useEffect(() => {
        if (visibilityExpanded.value) {
            lockExpanded.setFalse();
            integrationsExpanded.setFalse();
        }
    }, [visibilityExpanded.value]);

    useEffect(() => {
        if (integrationsExpanded.value) {
            lockExpanded.setFalse();
            visibilityExpanded.setFalse();
        }
    }, [integrationsExpanded.value]);

    return (
        <div>
            <GridLockMenu
                columns={columns}
                updateColumns={updateColumns}
                closeSettingsMenu={closeMenu}
                menuExpand={lockExpanded}
                lockedColumnsUpdated={lockedColumnsUpdated}
            />
            <GridVisibilityMenu
                columns={columns}
                updateColumns={updateColumns}
                closeSettingsMenu={closeMenu}
                menuExpand={visibilityExpanded}
                hiddenColumnsUpdated={hiddenColumnsUpdated}
            />
            {integrationsOptions && (
                <GridIntegrationsMenu
                    menuExpand={integrationsExpanded}
                    closeSettingsMenu={closeMenu}
                    integrationsConfig={integrationsOptions}
                />
            )}
        </div>
    );
};

export default GridSettingsMenu;
